import React from 'react'
import PropTypes from 'prop-types'

import SideBar from '../SideBar'
import Author from '../Author'
import Highlight from '../Highlight'

const Post = (props) => {
  const { bodyContent, image, author, video, podcast, type, slug, tweetText, createdAt } = props
  const url = `https://node.dev/post/${slug}`
  const typeCategory = {
    video: 'videos',
    blog: 'blogs',
    community: 'community',
    profile: 'community'
  }
  return (
    <div className='container'>
      <div className='row'>
        <div className='col-lg-8'>
          <div className='img-in margin-bottom-30px'>
            {
              (video || podcast)
                ? <iframe width='100%' title='video' height={podcast ? '300' : '487'} src={video || podcast} frameBorder='0' allow='encrypted-media' allowFullScreen />
                : <img className='border-radius-8 box-shadow' src={image.file.url} alt={image.file.fileName} />
            }
          </div>
          <div className='social-links margin-bottom-30px'>
            <span>SHARE</span>
            <ul className='social-icon style-2'>
              <li className='icon-twitter'>
                <a href={`https://www.twitter.com/intent/tweet?url=&amp;text=${tweetText}`} target='blank'><i className='fa fa-twitter' /></a>
              </li>
              <li className='icon-linkedin'>
                <a href={`https://www.linkedin.com/shareArticle?mini=true&amp;url=${url}`} target='blank'><i className='fa fa-linkedin' /></a>
              </li>
              <li className='icon-facebook'>
                <a href={`https://www.facebook.com/sharer/sharer.php?u=${url}`} target='blank'><i className='fa fa-facebook' /></a>
              </li>
              <li className='icon-gplus'>
                <a href={`https://plus.google.com/share?url=${url}`} target='blank'><i className='fa fa-google-plus' /></a>
              </li>
            </ul>
          </div>
          <div className='entry-content clearfix'>
            <Highlight content={bodyContent.childMarkdownRemark.html} />
          </div>
          <Author createdAt={createdAt} {...author} />
        </div>
        <div className='col-lg-4'>
          <SideBar type={typeCategory[type]} />
        </div>
      </div>
    </div>
  )
}

Post.propTypes = {
  video: PropTypes.string,
  author: PropTypes.shape(),
  bodyContent: PropTypes.shape(),
  image: PropTypes.shape(),
  type: PropTypes.string,
  slug: PropTypes.string,
  tweetText: PropTypes.string,
  createdAt: PropTypes.string
}

Post.defaultProps = {
  author: {},
  bodyContent: {},
  image: {},
  type: '',
  slug: '',
  tweetText: '',
  createdAt: ''
}

export default Post
